import axios from 'axios';
import { domain } from './domain';

export const getPayTrToken = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json', 
        },
        data,
    };
    return axios(domain + '/oxypay', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getDirectPayTrToken = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json', 
        },
        data,
    };
    return axios(domain + '/oxypay/direct', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getCardList = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json', 
        },
        data,
    };
    return axios(domain + '/oxypay/cardlist', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};
